import {
  keyOptionsMap, KEY_TYPE, OPERATOR_TYPE, SearchOptionsType, SEARCH_TYPE, valueMenuItemOptions,
} from 'pages/mailMagazine/type';
import { types, Actions } from './action';
import { MailMagazineAction, MailMagazineCreateEditType } from './index';


const initialState: MailMagazineCreateEditType = {
  mailMagazineSendCustomer: [],
  subject: null,
  body: null,
  signature: null,
  conditionType: SEARCH_TYPE.AND,
  sendCount: null,
  // loading: false,
  valueMenuItemOptionsState: valueMenuItemOptions,
  isComeFromHistory: false,
  sendFlag: false,
  error: null,
  searchConditionList: [{
    key: KEY_TYPE.CUSTOMER_NUMBER,
    conditionType: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfOperatorType || OPERATOR_TYPE.EQUAL,
    value: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfValueType || '',
  }],
  mailMagazineId: '',
  isReloadHistory: false,
  isInitData: false,
};

const reducer = (state = initialState, actions: Actions): MailMagazineCreateEditType => {
  if (actions.type === 'TEMPORARY_SAVE') {
    return {
      ...state,
      ...actions.payload,
    };
  }
  if (actions.type === 'SET_INITIAL_DATA') {
    const {
      data, isComeFromHistory, valueMenuItemOptionsState,
    } = actions.payload;

    return {
      ...state,
      // loading: false,
      valueMenuItemOptionsState,
      isComeFromHistory,
      subject: data?.subject ?? '',
      body: data?.body ?? '',
      signature: data?.signature ?? '',
      conditionType: data?.conditionType ?? SEARCH_TYPE.AND,
      sendFlag: data?.sendFlag ?? false,
      error: null,
      searchConditionList: (data?.searchConditionList && data?.mailMagazineId !== '') ? data?.searchConditionList : [{
        key: KEY_TYPE.CUSTOMER_NUMBER,
        conditionType: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfOperatorType || OPERATOR_TYPE.EQUAL,
        value: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfValueType || '',
      }],
      mailMagazineId: data?.mailMagazineId ?? '',
      isReloadHistory: isComeFromHistory,
      isInitData: true,
    };
  }

  if (actions.type === 'RELOAD_DETAIL_DATA') {
    const data = actions.payload;
    return {
      ...state,
      // loading: false,
      subject: data?.subject ?? '',
      body: data?.body ?? '',
      signature: data?.signature ?? '',
      conditionType: data?.conditionType ?? SEARCH_TYPE.AND,
      sendFlag: data?.sendFlag ?? false,
      error: null,
      searchConditionList: (data?.searchConditionList && data?.mailMagazineId !== '') ? data?.searchConditionList : [{
        key: KEY_TYPE.CUSTOMER_NUMBER,
        conditionType: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfOperatorType || OPERATOR_TYPE.EQUAL,
        value: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfValueType || '',
      }],
      mailMagazineId: data?.mailMagazineId ?? '',
    };
  }

  if (actions.type === 'SET_CONFIRM_DATA') {
    const { formData, mailMagazineSendCustomer } = actions.payload;
    return {
      ...state,
      ...formData,
      isComeFromHistory: true,
      error: null,
      mailMagazineSendCustomer,
      valueMenuItemOptionsState: state.valueMenuItemOptionsState,
    };
  }

  if (actions.type === 'CLEAR_DATA') {
    return {
      ...state,
      subject: null,
      body: null,
      signature: null,
      conditionType: SEARCH_TYPE.AND,
      sendCount: null,
      isComeFromHistory: false,
      sendFlag: false,
      mailMagazineSendCustomer: [],
      error: null,
      searchConditionList: [{
        key: KEY_TYPE.CUSTOMER_NUMBER,
        conditionType: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfOperatorType || OPERATOR_TYPE.EQUAL,
        value: keyOptionsMap.get(KEY_TYPE.CUSTOMER_NUMBER)?.defaultOfValueType || '',
      }],
      mailMagazineId: '',
    };
  }
  return state;
};

export default reducer;
